import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { ConfigContext, dataMaintainer } from './context';
import { LocaleProvider } from '../../LocaleProvider/rn';
export var ConfigProvider = function ConfigProvider(props) {
  var messages = props.messages,
    modals = props.modals,
    eventEmitter = props.eventEmitter,
    container = props.container,
    rootId = props.rootId,
    translations = props.translations,
    tracker = props.tracker,
    children = props.children,
    locale = props.locale,
    locales = props.locales,
    region = props.region,
    dontUseBodyAsDefaultContainer = props.dontUseBodyAsDefaultContainer;
  var _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    modalZIndex = _useState2[0],
    setModalZIndex = _useState2[1];
  var increaseModalZIndex = function increaseModalZIndex() {
    setModalZIndex(modalZIndex + 1);
  };
  dataMaintainer.updateTracker(tracker);
  return /*#__PURE__*/React.createElement(ConfigContext.Provider, {
    value: {
      messages: messages,
      eventEmitter: eventEmitter,
      rootId: rootId,
      translations: translations,
      container: container,
      modalZIndex: modalZIndex,
      increaseModalZIndex: increaseModalZIndex,
      modals: modals,
      dontUseBodyAsDefaultContainer: dontUseBodyAsDefaultContainer
    }
  }, /*#__PURE__*/React.createElement(LocaleProvider, {
    locale: locale,
    locales: locales,
    region: region
  }, children));
};